'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _session = require('./session');

var _session2 = _interopRequireDefault(_session);

/*******************************************************************************
 * The Root component handles the injection of the current session into the
 * context. Simply extend the top-most component in your hierarchy with the
 * Root in order to perform Query injections.
 */

var Root = (function (_React$Component) {
	_inherits(Root, _React$Component);

	function Root() {
		_classCallCheck(this, Root);

		_get(Object.getPrototypeOf(Root.prototype), 'constructor', this).apply(this, arguments);
	}

	_createClass(Root, [{
		key: 'getChildContext',
		value: function getChildContext() {
			return {
				$QUERY_SESSION: _session2['default'].Current || new _session2['default']()
			};
		}
	}], [{
		key: 'childContextTypes',
		get: function get() {
			return {
				$QUERY_SESSION: _react2['default'].PropTypes.instanceOf(_session2['default'])
			};
		}
	}]);

	return Root;
})(_react2['default'].Component);

exports['default'] = Root;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ../node_modules/acast-reactor/dist/root.js
// module id = Gzig
// module chunks = 15